import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      '&:hover': {
        borderColor: COLORS.gray.gray60,
        boxShadow: theme.shape.boxShadowMedium,
      },
    },
    title: {
      display: 'flex',
      columnGap: theme.spacing(1),
      alignItems: 'center',
      '& svg': {
        fontSize: theme.typography.pxToRem(20),
      },
    },
  }),
  { name: 'NewToneOfVoiceCard' }
);
